/**
 * Interstitiel entre manches.
 *
 * Il ne se declenche qu'a l'entree en REVEAL de la manche 2 d'une partie d'au
 * moins 5 manches : c'est-a-dire pendant un temps mort, jamais au milieu de
 * DRAWING, GUESSING ni d'une revelation en cours.
 *
 * Note : le stub ne bloque rien. Une vraie implementation devra, elle,
 * s'inserer dans une pause reelle, pas par-dessus l'ecran.
 */
import { useEffect, useRef } from 'react';
import { useRoomStore } from '../store/roomStore.js';
import { shouldShowRoundInterstitial, showInterstitial } from './adapter.js';

export function useRoundInterstitial(): void {
  const phase = useRoomStore((state) => state.room?.phase ?? null);
  const round = useRoomStore((state) => state.room?.round ?? 0);
  const totalRounds = useRoomStore((state) => state.room?.settings.rounds ?? 0);

  // Une seule fois par partie : la cle change au demarrage d'une nouvelle.
  const firedFor = useRef<string | null>(null);

  useEffect(() => {
    if (phase !== 'REVEAL') return;
    if (!shouldShowRoundInterstitial(round, totalRounds)) return;

    const key = `${totalRounds}:${round}`;
    if (firedFor.current === key) return;
    firedFor.current = key;

    void showInterstitial();
  }, [phase, round, totalRounds]);

  // Retour au lobby : la prochaine partie doit pouvoir en declencher un.
  useEffect(() => {
    if (phase === 'LOBBY') firedFor.current = null;
  }, [phase]);
}
